
import React, { Component } from "react";
import IntlMessages from "../../utils/IntlMessages";
import "moment/locale/th";
import moment from "moment";

class PopupTermCondition extends Component {
  
  constructor(props) {
    super(props);
    this.state={
      term : localStorage.getItem("term-agement"),
    }
  }
  
  render() { 
    const date = moment().format("YYYY-MM-DD")
    if(this.state.term){
      return <></>;
    }
     return (
      <div
        className="modal fade show"
        role="dialog"
        tabIndex="-1"
        style={{ display: "block" }}
      >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content white">
            <div className="modal-header" >
              เงื่อนไขการได้รับสิทธิประโยชน์
            </div>
            <div className="modal-body text-left">
            <h6 className="text-center font-weight-bolder" style={{fontSize:"19px",marginTop:'20px'}}>Eastspring Wealth Privilege Program 2023</h6>
              <section id="divR"  onScroll={this.onScroll} ref={input => {this.refs = input;}} style={{ overflowY: "scroll" , overflowX:"hidden", maxHeight : "400px"}}>
                เพราะคุณคือลูกค้าคนพิเศษของเรา บริษัทหลักทรัพย์จัดการกองทุน อีสท์สปริง (ประเทศไทย) จำกัด รู้สึกเป็นเกียรติในการส่งมอบเอกสิทธิ์เหนือระดับ พร้อมเติมเต็มประสบการณ์ในทุกไลฟ์สไตล์ที่คัดสรรมาเพื่อท่านโดยเฉพาะ
                <h6 className="font-weight-bolder" style={{fontSize:"19px",marginTop:'20px'}}>ระดับสถานะของสมาชิก Eastspring Wealth Privilege Program</h6>
                <ul>
                  <li>
                      พิจารณามอบสิทธิประโยชน์การเป็นสมาชิก สำหรับลูกค้าที่มียอดสินทรัพย์ลงทุนย้อนหลังเฉลี่ย 12 เดือน (มกราคม 2565 – ธันวาคม 2565) ตั้งแต่ 10 ล้านบาทขึ้นไป โดยกำหนดระดับสถานะของสมาชิก ตามเกณฑ์ ดังนี้
                    <ul>
                      <li>สถานะ Elite ยอดเงินทุน (AUM) ตั้งแต่ 100 ล้านบาทขึ้นไป จะได้รับ 10,000 คะแนน</li>
                      <li>สถานะ Stellar ยอดเงินทุน (AUM) ตั้งแต่ 50ล้าน - 	&#60;100 ล้านบาทขึ้นไป จะได้รับ 5,000 คะแนน</li>
                      <li>สถานะ Prime ยอดเงินทุน (AUM) ตั้งแต่ 10ล้าน - 	&#60;50 ล้านบาทขึ้นไป จะได้รับ 2,000 คะแนน</li>
                    </ul>
                  </li>
                  <li>บลจ.อีสท์สปริง จะทบทวนการมอบสิทธิประโยชน์สำหรับสมาชิก เป็นรายไตรมาส โดยพิจารณาจากยอดสินทรัพย์ลงทุนย้อนหลังเฉลี่ย 3 เดือน (ณ วันที่ 31 มีนาคม  30 มิถุนายน และ 30 กันยายน 2566)</li>
                </ul>
                หมายเหตุ : 
                <ul>
                  <li>ขอสงวนสิทธิ์ในการมอบสิทธิประโยชน์สำหรับสมาชิก <b className="font-weight-bolder">Eastspring Wealth Privilege Program</b> เฉพาะลูกค้าบุคคลธรรมดา ที่มียอดเงินลงทุนเป็นไปตามเงื่อนไขที่บริษัทกำหนด</li>
                  <li>โปรแกรม <b className="font-weight-bolder">Eastspring Wealth Privilege</b> และคะแนนที่ได้รับ สามารถใช้แลกรับของกำนัลได้ถึงวันที่ 29 ธันวาคม 2566 เท่านั้น</li>
                  <li>สำหรับกองทุนรวมที่เป็นบัญชีร่วม บลจ.อีสท์สปริง ขอสงวนสิทธิ์ในการมอบสถานะการเป็นสมาชิก Eastspring Wealth Privilege ให้กับผู้เป็นเจ้าของบัญชีหลัก (ตามเลขที่บัตรประชาชนหลัก) เท่านั้น</li>
                </ul>
                <div>
                <label htmlFor="agreement"></label>
                </div>
                    <button type="button" className={"btn btn-wrs mb-3"}
                      onClick={() => {
                        localStorage.setItem("term-agement",date);
                        this.props.setDisplay();
                        this.setState({
                          term: date
                        })
                      }}
                    >
                      <IntlMessages id="consent.accept"></IntlMessages>
                    </button>
              </section>
            </div>
        </div>
      </div>
    </div>
    );
  }
}

export default PopupTermCondition;
